<div class="add-meter-dialog">
  <h2 mat-dialog-title class="perse-dialog-title">Add New Address</h2>
  
  <mat-dialog-content #dialogContent class="px-1 lg-dialog">
    <form [formGroup]="meterForm">
      <mat-horizontal-stepper #stepper [linear]="true">
      <!-- Step 1: Address Details -->
      <!-- Note: We use the terminology 'Address' instead of 'Meter' for the end user but we continue to use 'Meter' in the code -->
      <mat-step [completed]="isMeterStepValid()">
        <ng-template matStepLabel>{{ isMultiMeterMode ? 'Load Meters' : 'Address Details' }}</ng-template>
        
        <!-- Multi-meter mode -->
        @if (isMultiMeterMode) {
          @if (uploadedMeters.length === 0) {
            <h5>Load Meters</h5>
            <p>Something went wrong...</p>


            <!-- <h5>Upload Excel File with Meter Details</h5>
            <p>Please upload an Excel file containing meter numbers, addresses, and fuel types.</p>
            
            <div class="excel-upload-section">
              <input type="file" 
                     (change)="onExcelFileSelected($event)" 
                     accept=".xlsx,.xls" 
                     #fileInput 
                     style="display: none;">
              
              <button mat-flat-button color="primary" (click)="fileInput.click()" [disabled]="isProcessingExcel">
                <mat-icon>upload_file</mat-icon>
                Choose Excel File
              </button>
              
              @if (isProcessingExcel) {
                <div class="progress-indicator">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  <p>Processing Excel file...</p>
                </div>
              }
            </div> -->
          }
          
          @if (uploadedMeters.length > 0) {
            <h5>Loaded Meters ({{ uploadedMeters.length }})</h5>
            <p>You have been requested to add the following meters. Select the meters you want to add:</p>
            
            @if (getSelectedMeterCount() > 0) {
              <div class="selection-info">
                <mat-icon class="success-icon icon-no-shrink">check_circle</mat-icon>
                <span>{{ getSelectedMeterCount() }} meter(s) selected</span>
              </div>
            }
            
            <app-generic-table 
              [data]="uploadedMeters"
              [columns]="multiMeterColumns"
              [config]="multiMeterTableConfig"
              (selectedRows)="onMeterSelectionChange($event)">
            </app-generic-table>
            
            <!-- <div class="upload-actions">
              <button mat-button (click)="uploadedMeters = []">
                <mat-icon>refresh</mat-icon>
                Upload Different File
              </button>
            </div> -->
          }
        }
        
        <!-- Single meter mode (existing content) -->
        @if (!isMultiMeterMode) {
          <app-meter-selection 
            [initialValue]="initialFormValue()" 
            [supportedMeterTypes]="supportedMeterTypes"
            formControlName="selectedMeter">
          </app-meter-selection>
        } <!-- End of single meter mode -->
        
      </mat-step>

      <!-- Step 2: Relationship with Property -->
      <mat-step [completed]="isRelationshipStepCompleted()">
        <ng-template matStepLabel>Relationship</ng-template>
        <div formGroupName="relationship">
          <div class="relationship-section">
            <h5>What is your relationship with this property?</h5>
            <p>Please select the option that best describes your relationship with the property (choose Occupier if you are both this and the bill payer)</p>
            
            <app-custom-radio-button
              [options]="relationshipOptions()"
              formControlName="type"
              (selectionChange)="onRelationshipTypeChange($event)">
            </app-custom-radio-button>

            <!-- Option 3: Company with legitimate interest - Company search only -->

            @if (isCompanyUser) {
              @if (meterForm.get('relationship.type')?.value === 'landlord') {
                <app-company-selection></app-company-selection>
              }
            }
          </div>
        </div>

      </mat-step>
      
      <!-- Step 3: Consent -->
      <mat-step>
        <ng-template matStepLabel>Consent</ng-template>
          <div formGroupName="consentDetails">

             @if (getConsentCategory() === 'CHECKBOX') {
              <h4>Consent Details</h4>
             } @else if (getConsentCategory() === 'SMART_METER') {
              <h4>Smart Meter Consent</h4>
             } @else {
              <h4>Letter of Authority (LoA)</h4>
             }

              <!-- Consent Expiry Date - Common for all meter types -->
              <div class="consent-expiry-date">
                <h5>Expiry Date</h5>
                <p>Please select when your consent will expire. We will notify you before expiration. Expiry date should be atleast a month from today.</p>
                <mat-form-field subscriptSizing="dynamic" appearance="fill">
                  <mat-label>Consent Expiry Date</mat-label>
                  <input matInput [matDatepicker]="expiryPicker" formControlName="expiryDate" 
                         [min]="minExpiryDate" [max]="maxExpiryDate">
                  <mat-datepicker-toggle matIconSuffix [for]="expiryPicker"></mat-datepicker-toggle>
                  <mat-datepicker #expiryPicker></mat-datepicker>
                  @if (meterForm.get('consentDetails.expiryDate')?.errors?.['required']) {
                    <mat-error>
                      Expiry date is required
                    </mat-error>
                  }
                  @if (meterForm.get('consentDetails.expiryDate')?.errors?.['matDatepickerMin']) {
                    <mat-error>
                      Expiry date must be at least 30 days from today
                    </mat-error>
                  }
                  @if (meterForm.get('consentDetails.expiryDate')?.errors?.['matDatepickerMax']) {
                    <mat-error>
                      Expiry date cannot be more than 3 years from today
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              
              <!-- Letter of Authority (LoA) for Half Hourly meters -->
              @if (getConsentCategory() === 'LOA') {
                <app-add-hh-consent
                  [relationshipType]="meterForm.get('relationship.type')?.value"
                  [selectedMeters]="getSelectedMeters()"
                  formControlName="consent">
                </app-add-hh-consent>
              }
              
              <!-- Smart Meter Consent for Smart meters -->
              @if (getConsentCategory() === 'SMART_METER') {
                <app-add-smart-consent
                  #addSmartConsent
                  [relationshipType]="meterForm.get('relationship.type')?.value"
                  [selectedMeters]="getSelectedMeters()"
                  [supportedSmartMeterConsentTypes]="supportedSmartMeterConsentTypes"
                  (triggerAutoScroll)="scrollToEndOfDialog()"
                  formControlName="consent">
                </app-add-smart-consent>
              }
              
              <!-- Only show checkbox consent for Non Half Hourly meters -->
              @if (getConsentCategory() === 'CHECKBOX') {
                <app-add-nhh-consent formControlName="consent">
                </app-add-nhh-consent>
              }
                
          </div>
      </mat-step>
    </mat-horizontal-stepper>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">
      {{ isConsentRequestMode ? 'Skip' : 'Cancel' }}
    </button>
    @if (stepper && stepper.selectedIndex > 0) {
      <button mat-button (click)="stepper.previous()">Back</button>
    }
    @if (stepper) {
      @switch (stepper.selectedIndex) {
        @case (0) {
          @if (isConsentRequestMode) {
            <button mat-button color="warn" (click)="decline()">Decline</button>
          }
          <button mat-flat-button [disabled]="!isMeterStepValid()" (click)="stepper.next()">Next</button>
        }
        @case (1) {
          <button mat-flat-button [disabled]="!isRelationshipStepCompleted()" (click)="stepper.next()">Next</button>
        }
        @case (2) {
            <button mat-flat-button color="primary" [disabled]="!meterForm.valid || uploadingConsent" (click)="submit()">
            <span *ngIf="uploadingConsent">Please wait...</span>
            <span *ngIf="!uploadingConsent">Finish</span>
            </button>
        }
      }
    }
  </mat-dialog-actions>
</div>
